import Vue from 'vue'
import store from '@/store'
let KnowledgeDlgConstructor = Vue.extend(require('./main.vue'))

let instance

var knowledgeDlg = function (options) {
  options = options || {}
  if (!instance) {
    instance = new KnowledgeDlgConstructor({
      data: options,
      store: store
    })
    instance.vm = instance.$mount()
    document.body.appendChild(instance.vm.$el)
  }

  instance.vm.guid = options.guid
  instance.vm.isEditData = options.isEditData
  instance.vm.loadData()
  instance.vm.show = true
  return instance.vm
}

export default knowledgeDlg



// WEBPACK FOOTER //
// ./src/components/knowledgeDlg/src/main.js